export const MAIN_AWNING_CATALOG_PRODUCT_ID = "69832bf1412f46e3c0c8dec7";

const awningMainTitleByItemType = {
    aluminiumComposite: "Aluminium Composite Panel C/W Metal Frame",
    aluminiumCBond: "Aluminium C-Bond",
    glass: "Safety Laminated Glass C/W Metal Frame",
    polyCarbonate: "Polycarbonate Sheet C/W Metal Frame",
    polycarbonate: "Polycarbonate Sheet C/W Metal Frame",
    metalDeck: "Metal Deck PU Foam C/W Metal Frame",
    metalDeck2Layer: "Metal Deck PU Foam C/W Metal Frame",
    retractableSystem: "Retracable System",
    retracableSystem: "Retracable System",
    aluminiumStrip: "Aluminium Strip Ceiling",
};

const awningTypeLabels = {
    glass: "Glass Roof",
    aluminiumComposite: "Aluminium Composite Roof",
    aluminiumCBond: "Aluminium C-Bond",
    polyCarbonate: "Polycarbonate Roof",
    polycarbonate: "Polycarbonate Roof",
    metalDeck: "Metal Deck Roof",
    aluminiumStrip: "Aluminium Strip Ceiling",
    retractableSystem: "Retractable System",
    others: "Others",
};

export const getOrderProductIdString = (productRow) => {
    const pid = productRow?.productId;
    if (pid == null) return "";
    if (typeof pid === "object") {
        const id = pid._id ?? pid.id;
        return id != null ? String(id) : "";
    }
    return String(pid);
};

export const isMainAwningCatalogProduct = (productRow) =>
    getOrderProductIdString(productRow) === MAIN_AWNING_CATALOG_PRODUCT_ID;

export const isOthersOrderLine = (productRow) => {
    const ic = String(productRow?.itemCode || "").toUpperCase();
    if (ic === "OTHERS") return true;
    if (String(productRow?.type || "").toLowerCase() === "others") return true;
    if (String(productRow?.typeDescription || "").toLowerCase() === "others")
        return true;
    const pid = productRow?.productId;
    if (pid && typeof pid === "object") {
        if (String(pid.title || "").toLowerCase() === "others") return true;
    }
    if (Array.isArray(productRow?.items)) {
        return productRow.items.some((it) => {
            const typ = String(it?.type || "").toLowerCase();
            const td = String(it?.typeDescription || "").toLowerCase();
            return typ === "others" || td === "others";
        });
    }
    return false;
};

const getFirstProductItemType = (productRow) => {
    if (Array.isArray(productRow?.items) && productRow.items.length > 0) {
        return productRow.items[0].type;
    }
    return productRow?.type;
};

export const getAwningMainTitle = (productRow) => {
    const itemType = getFirstProductItemType(productRow);
    if (itemType && awningMainTitleByItemType[itemType]) {
        return awningMainTitleByItemType[itemType];
    }
    return null;
};

/** Human-readable product name for order history / modals (matches invoice title logic). */
export const getOrderProductDisplayName = (productRow) => {
    if (!productRow) return "Item";

    if (isOthersOrderLine(productRow)) {
        const raw = productRow.code;
        if (raw !== undefined && raw !== null) {
            const code = String(raw).trim();
            if (code && code.toUpperCase() !== "OTHERS") return code;
        }
        return (
            productRow.typeDescription ||
            productRow.type ||
            awningTypeLabels.others
        );
    }

    if (isMainAwningCatalogProduct(productRow)) {
        return (
            getAwningMainTitle(productRow) ||
            productRow.typeDescription ||
            awningTypeLabels[productRow.type] ||
            productRow.type ||
            "Awning"
        );
    }

    const codeStr = String(productRow.code ?? "").trim();
    if (codeStr) return codeStr;

    return (
        productRow.typeDescription ||
        productRow.type ||
        productRow.model ||
        "Item"
    );
};

export const getOrderProductQuantity = (productRow) =>
    productRow?.quantity ?? productRow?.amount ?? 1;

export const getOrderProductUnitPrice = (productRow) =>
    Number(productRow?.price) || 0;

export const getOrderProductLineTotal = (productRow) =>
    getOrderProductUnitPrice(productRow) * getOrderProductQuantity(productRow);
